"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const moment_1 = __importDefault(require("moment"));
const application_config_1 = __importDefault(require("../../../config/application.config"));
const StartedAndCompletedInterviewByDay_1 = __importDefault(require("../monitoring/StartedAndCompletedInterviewByDay"));
const ProgressionMonitoringCharts_1 = require("../monitoring/ProgressionMonitoringCharts");
const ExportInterviewData_1 = __importDefault(require("./ExportInterviewData"));
const Monitoring = () => {
    const [lastUpdateAt, setLastUpdateAt] = react_1.default.useState(undefined);
    // import custom admin monitoring components if available in the project directory:
    const customMonitoringComponents = react_1.default.useMemo(() => application_config_1.default.getAdminMonitoringComponents(), []);
    const onUpdate = () => {
        setLastUpdateAt((0, moment_1.default)().unix());
    };
    const customMonitoringComponentsArray = customMonitoringComponents.map((Component, i) => (react_1.default.createElement(Component, { onUpdate: onUpdate, lastUpdateAt: lastUpdateAt, key: `customMonitoringComponent${i + 1}` })));
    return (react_1.default.createElement("div", { className: "survey" },
        react_1.default.createElement("div", { className: "monitoring" },
            react_1.default.createElement("div", { className: "monitoring-first-row" },
                react_1.default.createElement(StartedAndCompletedInterviewByDay_1.default, null),
                react_1.default.createElement(ExportInterviewData_1.default, null)),
            react_1.default.createElement(ProgressionMonitoringCharts_1.ProgressionMonitoringCharts, null),
            customMonitoringComponentsArray)));
};
exports.default = Monitoring;
//# sourceMappingURL=Monitoring.js.map